<template>

    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">设备报警记录</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">设备号</div>
                    <div class="header-item">设备序列号</div>
                    <div class="header-item">告警名称</div>
                    <div class="header-item">告警类型</div>

                    <div class="header-item">告警状态</div>
                    <div class="header-item">告警时间</div>
                    <div class="header-item">告警信息</div>

                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in paginatedList" :key="index">
                            <div class="body-item">{{ item.deviceId }}</div>
                            <div class="body-item">{{ item.serialNumber }}</div>
                            <div class="body-item">{{ item.alarmName }}</div>
                            <div class="body-item"> {{ item.alarmType }}</div>
                            <div class="body-item"> {{ item.alarmStatus }}</div>
                            <div class="body-item"> {{ item.alarmTime }}</div>
                            <div class="body-item"> {{ item.alarmInfo }}</div>
                        </div>
                        <div class="empty-tip" v-if="paginatedList.length === 0">
                            暂无告警记录
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>

</template>

<script>
import { getDeviceAlarm } from "@/api/alarm";

export default {
    data() {
        return {
            // 表格数据和分页
            list: [], // 原始完整数据
            loading: false,
            currentPage: 1,
            pageSize: 10,

            // 选中的ID数组（批量删除用）
            selectedIds: [],

            // 搜索关键词（用于设备序列号搜索）
            searchKeyword: '',

            // 冗余字段（保留，不影响功能）
            searchForm: {
                houseId: '',
                code: '',
            },
            dialogVisible: false,
            dialogTitle: '新增配件',
            formRef: null,
            form: {
                id: '',
                accessoriesName: '',
                accessoriesType: '',
                remark: '',
                unit: '',
                userid: localStorage.getItem('userId')
            },

        };
    },
    computed: {
        // 核心修改：仅根据设备序列号（serialNumber）过滤列表
        filteredList() {
            if (!this.searchKeyword) {
                return this.list; // 无关键词时返回全部数据
            }
            // 统一转小写，去除空格，实现不区分大小写+精准模糊匹配
            const keyword = this.searchKeyword.trim().toLowerCase();
            return this.list.filter(item => {
                // 仅匹配设备序列号，空值跳过
                return item.serialNumber && item.serialNumber.toLowerCase().includes(keyword);
            });
        },
        // 过滤后的总数（分页用）
        filteredTotalCount() {
            return this.filteredList.length;
        },
        // 分页后的列表
        paginatedList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredList.slice(start, end);
        }
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取告警列表数据
        getList() {
            this.loading = true;
            getDeviceAlarm({
                userid: localStorage.getItem('userId')
            }).then(response => {
                this.list = response.data || [];
                // 清空选中状态
                this.selectedIds = [];
                this.$nextTick(() => {
                    if (this.$refs.tableRef) {
                        this.$refs.tableRef.clearSelection();
                    }
                });
            }).catch(error => {
                console.error('获取告警列表失败:', error);
                this.$message.error('获取告警列表失败，请稍后重试');
                this.list = [];
            }).finally(() => {
                this.loading = false;
            });
        },





    }
};
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>